import { PoolConfig, QuoteToken, PoolCategory } from './types'

const pools: PoolConfig[] = [
  {
    sousId: 0,
    tokenName: 'VOTE',
    tokenAddress: '0x634D10911a59651E8344691c35d6a4545f7934A1',   // token address
    stakingTokenName: QuoteToken.CAKE,
    stakingTokenAddress: '0x634D10911a59651E8344691c35d6a4545f7934A1',  // token address
    contractAddress: {
      97: '',
      56: '0x23A3837E85E8a3F1f29f4cA3bFeac241f53847B8',  /// masterchef address
    },
    poolCategory: PoolCategory.CORE,
    projectLink: '/',
    harvest: true,
    tokenPerBlock: '10',
    sortOrder: 1,
    isFinished: false,
    tokenDecimals: 18,
  },
 
]

export default pools
